import { useEffect, useState } from "react";
import { onIdTokenChanged } from "firebase/auth";
import { auth } from "../firebase";

export default function useAdmin() {
  const [state, setState] = useState({ loading: true, isAdmin: false });
  useEffect(() => {
    let generation = 0;
    let active = true;
    const unsubscribe = onIdTokenChanged(auth, async (user) => {
      const current = ++generation;
      setState({ loading: true, isAdmin: false });
      try {
        const token = user ? await user.getIdTokenResult() : null;
        if (active && current === generation) setState({ loading: false, isAdmin: token?.claims.admin === true });
      } catch {
        if (active && current === generation) setState({ loading: false, isAdmin: false });
      }
    });
    return () => { active = false; unsubscribe(); };
  }, []);
  return state;
}
